import { Truncate } from "@dropbox/dig-components/truncate";
import { Text } from "@dropbox/dig-components/typography";
import { Box, Stack } from "@dropbox/dig-foundations";
import * as React from "react";
import styles from "./MathShowcase.module.css";

export interface MathShowcaseProps {
  /**
   * The mathematical equation to display
   */
  equation: string;

  /**
   * The solution to the equation
   */
  solution: string;
}

/**
 * MathShowcase displays a mathematical expression.
 */
export const MathShowcase: React.FC<MathShowcaseProps> = ({
  equation,
  solution,
}) => {
  return (
    <Box width="100%">
      <Stack width="100%" gap="4">
        <Box
          width="100%"
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          <Text color="subtle">{`${equation} =`}</Text>
        </Box>
        <Text variant="label" className={styles.solutionText}>
          <Truncate>{solution}</Truncate>
        </Text>
      </Stack>
    </Box>
  );
};
